module.exports = __webpack_public_path__ + "img/tres_puntos_claro.096f2ce9.svg";